import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import ImageSize from '../ImageSize/ImageSize';
import Account from '../../modules/Account/Account';
import Users from '../../modules/Users/Users';

import logoutIcon from '../../assets/images/logout.svg';

import './Profile.scss';

class Profile extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      popupVisible: false,
    };
  }

  handleClick() {
    if (!this.state.popupVisible) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      popupVisible: !prevState.popupVisible,
    }));
  }

  handleOutsideClick(e) {
    // if (this.node.contains(e.target)) {
    // 	return;
    // }

    this.handleClick();
  }

  render() {
    let { className, user, email, onChange, onClick, profileImage } = this.props;

    return (
      <div
        className={`profile ${className}`}
        ref={(node) => {
          this.node = node;
        }}
      >
        <div className='profile_image' onClick={this.handleClick}>
          <ImageSize src={profileImage} alt="#" />
        </div>
        <div className='dropdown_user' style={{ display: this.state.popupVisible ? 'flex' : 'none' }}>
          <div className='profile_content'>
            <div className='profile-info'>
              <div className='profile_text'>
                <h2>{user}</h2>
                <p>{email}</p>
              </div>
              <div className='avatar_change'>
                <ImageSize src={profileImage} alt="" />
              </div>
            </div>

            <div className='profile-buttons'>
              <Account>
                <Button variant='secondary' size='sm'>
                  Account
                </Button>
              </Account>
              <Users>
                <Button variant='secondary' size='sm'>
                  Users
                </Button>
              </Users>
            </div>            
          </div>
          <div className='profile_footer'>
            <Button onClick={onClick} onChange={onChange} variant="primary-link" size="md">
              Sign out <img src={logoutIcon} alt="" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  className: PropTypes.string,
  user: PropTypes.string,
  email: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  profileImage: PropTypes.string.isRequired,
};

export default Profile;
